/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventDay,
    JsonEventDayFromJSON,
    JsonEventDayFromJSONTyped,
    JsonEventDayToJSON,
} from './JsonEventDay';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventDay
 */
export interface ApiResultOfJsonEventDay {
    /**
     * 
     * @type {JsonEventDay}
     * @memberof ApiResultOfJsonEventDay
     */
    data?: JsonEventDay;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDay
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventDay
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDay
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventDay
     */
    result?: ApiResultOfJsonEventDayResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventDayResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventDayFromJSON(json: any): ApiResultOfJsonEventDay {
    return ApiResultOfJsonEventDayFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventDayFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventDayToJSON(value?: ApiResultOfJsonEventDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventDayToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

